import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Page } from "../components/site";
import { SITE } from "../lib/seo-data";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy en cookies | offerto" },
      { name: "description", content: "Lees hoe offerto websitebezoek en offerteaanvragen meet en hoe je je cookievoorkeuren wijzigt." },
      { property: "og:title", content: "Privacy en cookies | offerto" },
      { property: "og:description", content: "Informatie over de meting van websitebezoek en aanvragen en je cookiekeuze." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: `${SITE}/privacy` }],
  }),
  component: Privacy,
});

function Privacy() {
  return (
    <Page title="Privacy en cookies" intro="Je kiest zelf of we je bezoek en aanvraag voor advertentiemeting gebruiken.">
      <div className="mt-10 max-w-3xl space-y-8 leading-relaxed">
        <section>
          <h2 className="text-xl font-bold">Aanvragen</h2>
          <p className="mt-2">Voor je offerteaanvraag verwerken we de gegevens die je invult, waaronder je adres, contactgegevens, klusomschrijving en eventuele foto’s. We delen je aanvraag met onze partner en met maximaal 5 aangesloten vakbedrijven in jouw regio om offertes mogelijk te maken. Vakbedrijven zien eerst alleen de klus, plaats, regio en foto’s; je naam, adres en contactgegevens krijgen ze pas als ze je aanvraag afnemen. Ook als je de aanvraag niet afrondt, bewaren we de al ingevulde gegevens om de aanvraagstappen te verbeteren.</p>
        </section>
        <section>
          <h2 className="text-xl font-bold">Meting met Google en Meta</h2>
          <p className="mt-2">Als je op Accepteren klikt, gebruiken we Google Analytics, Google Ads, Google Tag Manager en de Meta-pixel (Facebook/Instagram) om bezoek en het succesvol verzenden van aanvragen te meten en advertenties te beoordelen en optimaliseren. Bij een verzonden aanvraag delen we voor de meting alleen de gebeurtenis en een willekeurig aanvraagnummer; geen naam, e-mailadres, telefoonnummer, postcode of klusomschrijving. Google en Meta kunnen daarbij cookies en online identificatoren verwerken. We meten geen aanvraagconversie voor Google Ads of Meta wanneer je weigert.</p>
        </section>
        <section>
          <h2 className="text-xl font-bold">Je keuze wijzigen</h2>
          <p className="mt-2">Je kunt altijd weigeren of je eerdere keuze wijzigen. Dat verandert je mogelijkheid om een aanvraag te doen niet. Je keuze wordt in je browser onthouden; na intrekking sturen we geen nieuwe aanvraagmeting voor Google Ads of Meta.</p>
          <Button type="button" variant="outline" className="mt-4" onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}>Cookie-instellingen</Button>
        </section>
      </div>
    </Page>
  );
}